import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center smooth-corners-lg uppercase font-medium text-xs px-2.5 py-0.5",
  {
    variants: {
      variant: {
        default: "bg-muted text-foreground",
        secondary: "bg-secondary text-secondary-foreground",
        destructive:
          "bg-destructive/10 text-destructive dark:bg-destructive/20",
        "opportunity-won":
          "bg-supporting-green/10 text-supporting-green dark:bg-supporting-green/20",
        "opportunity-lost":
          "bg-supporting-red/10 text-supporting-red dark:bg-supporting-red/20",
        "opportunity-active":
          "bg-supporting-blue/10 text-supporting-blue dark:bg-supporting-blue/20",
        "opportunity-type": "bg-muted text-muted-foreground",
        "category-account":
          "bg-supporting-blue/10 text-supporting-blue dark:bg-supporting-blue/20",
        "category-opportunity":
          "bg-supporting-green/10 text-supporting-green dark:bg-supporting-green/20",
        "category-person":
          "bg-supporting-purple/10 text-supporting-purple dark:bg-supporting-purple/20",
        "category-campaign":
          "bg-supporting-orange/10 text-supporting-orange dark:bg-supporting-orange/20",
        "category-touchpoint": "bg-primary/10 text-primary dark:bg-primary/20",
        "category-other": "bg-muted text-muted-foreground",
        "team-sky":
          "bg-supporting-blue/10 text-supporting-blue dark:bg-supporting-blue/20",
        "team-emerald":
          "bg-supporting-green/10 text-supporting-green dark:bg-supporting-green/20",
        "team-violet":
          "bg-supporting-purple/10 text-supporting-purple dark:bg-supporting-purple/20",
        "team-amber":
          "bg-supporting-yellow/10 text-supporting-yellow dark:bg-supporting-yellow/20",
        "team-indigo":
          "bg-supporting-blue/10 text-supporting-blue dark:bg-supporting-blue/20",
        "team-teal": "bg-primary/10 text-primary dark:bg-primary/20",
        "team-rose":
          "bg-supporting-red/10 text-supporting-red dark:bg-supporting-red/20",
        "team-blue":
          "bg-supporting-blue/10 text-supporting-blue dark:bg-supporting-blue/20",
        "team-unknown": "bg-muted text-muted-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {
  startIcon?: React.ReactNode;
}

function Badge({
  className,
  variant,
  startIcon,
  children,
  ...props
}: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props}>
      {startIcon && <span className="mr-1">{startIcon}</span>}
      {children}
    </div>
  );
}

export { Badge, badgeVariants };
